import { observer, PropTypes as MobxPropTypes } from 'mobx-react'
import React from 'react'
import ResizeDetector from 'react-resize-detector'

import { Button, Col, Row } from 'antd'
import PropTypes from 'prop-types'

import { VIDEOS_ASPECT_RATIO_INDEX } from '../../../constants'
import { conditionedClassName } from '../../../helpers/common'
import VideoPlayer from './VideoPlayer'

const CeremonyMusicModalItem = ({
  performance,
  selectCeremonyPerformance,
  selectCeremonyPerformanceLoading,
  booking,
}) => {
  const { id, moreInfo, name, price, selected, videos } = performance

  return (
    <div className="band-modal-content-ceremony-list-item">
      <ResizeDetector handleWidth>
        {({ width }) => (
          <div
            style={{
              height: `${width * VIDEOS_ASPECT_RATIO_INDEX}px`,
            }}
            className="band-modal-content-ceremony-list-item__video"
          >
            {videos?.length > 0 && (
              <VideoPlayer
                src={videos[0].videoUrl}
                poster={videos[0].thumbnailUrl}
                key={videos[0].thumbnailUrl}
              />
            )}
          </div>
        )}
      </ResizeDetector>
      <div className="band-modal-content-ceremony-list-item__header">
        <div className="band-modal-content-ceremony-list-item__title">
          {name}
        </div>
        <div className="band-modal-content-ceremony-list-item__price mobile">
          <span
            className={conditionedClassName({
              'band-modal-content-ceremony-list-item__price-text': true,
              'blur-item': !booking.id,
            })}
          >
            Price
          </span>
          <span
            className={conditionedClassName({
              'band-modal-content-ceremony-list-item__price-number': true,
              'blur-item': !booking.id,
            })}
          >
            $ {price}
          </span>
        </div>
      </div>
      <div
        className="band-modal-content-ceremony-list-item__description qb-scroll-has-track-piece"
        dangerouslySetInnerHTML={{ __html: moreInfo }} // eslint-disable-line
      />
      <Row
        className="band-modal-content-ceremony-list-item__price-line"
        gutter={[0, 20]}
      >
        <Col xs={0} xl={12}>
          <div className="band-modal-content-ceremony-list-item__price">
            <span
              className={conditionedClassName({
                'band-modal-content-ceremony-list-item__price-text': true,
                'blur-item': !booking.id,
              })}
            >
              Price
            </span>
            <span
              className={conditionedClassName({
                'band-modal-content-ceremony-list-item__price-number': true,
                'blur-item': !booking.id,
              })}
            >
              $ {price}
            </span>
          </div>
        </Col>
        <Col xs={24} xl={12}>
          <div className="band-modal-content-ceremony-list-item__button">
            {selected ? (
              <Button
                type="primary"
                className="qb-button qb-button-change selected"
              >
                Selected
              </Button>
            ) : (
              <Button
                type="primary"
                className="qb-button qb-button-change ceremony-select-button"
                onClick={() => selectCeremonyPerformance(id)}
                disabled={selectCeremonyPerformanceLoading}
              >
                Select
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

CeremonyMusicModalItem.propTypes = {
  booking: MobxPropTypes.objectOrObservableObject,
  performance: MobxPropTypes.objectOrObservableObject,
  selectCeremonyPerformance: PropTypes.func.isRequired,
  selectCeremonyPerformanceLoading: PropTypes.bool.isRequired,
}

CeremonyMusicModalItem.defaultProps = {
  booking: {},
  performance: {},
}

export default observer(CeremonyMusicModalItem)
